import React from 'react';
import { DocumentDuplicateIcon, TrashIcon } from '@heroicons/react/24/outline';
import { useLanguage } from '@/state/language/LanguageProvider';
import { AE_ICON_SIZE } from '@/components/assessment-engine/layout/aeTheme';
import { BuilderIconButton } from './BuilderIconButton';

interface BuilderActionBarProps {
  onCopy: () => void;
  onDelete: () => void;
  disabled?: boolean;
}

/** Copy / delete icon toolbar for builder sections and questions. */
export const BuilderActionBar: React.FC<BuilderActionBarProps> = ({
  onCopy,
  onDelete,
  disabled,
}) => {
  const { t } = useLanguage();

  if (disabled) return null;

  return (
    <div className="flex flex-wrap gap-1 justify-end">
      <BuilderIconButton label={t('assessmentEngine.builder.copy')} onClick={onCopy}>
        <DocumentDuplicateIcon className={AE_ICON_SIZE} aria-hidden />
      </BuilderIconButton>
      <BuilderIconButton label={t('assessmentEngine.builder.delete')} onClick={onDelete} variant="danger">
        <TrashIcon className={AE_ICON_SIZE} aria-hidden />
      </BuilderIconButton>
    </div>
  );
};
